import { Component, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SortEnum } from 'src/app/shared/components/list-table/enums/sortEnum.enum';
import { OrdenTable } from '../../interfaces/table';
import { headersTable } from '../../interfaces/headers';
import { MatTableDataSource } from '@angular/material/table';
import { ActionOptions } from '../../interfaces/actionOption';
import { Router } from '@angular/router';
import { DetailPaymentService } from 'src/app/pages/detail-pay/services/detail.payment.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ConfirmarDialogComponent } from '../confirmar-dialog/confirmar-dialog.component';
import { PaymentsService } from 'src/app/core/services/payments.service';
import { PaymentIconsService } from 'src/app/core/services/payment-icons.service';
import { AppIcon } from '../../interfaces/app-icon';
import { DetailPayComponent } from 'src/app/pages/detail-pay/detail-pay.component';
import { ɵɵnextContext } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NativeBridgeService } from 'src/app/core/services/native-bridge.service';

@Component({
  selector: 'app-list-table',
  templateUrl: './list-table.component.html',
  styleUrls: ['./list-table.component.scss']
})
export class ListTableComponent {
  /**
   * ######################## COMPONENTE DEPRECADO - EN USO: movements-list #########################
   */

  public static readonly DEFAULT_PAGESIZE = 5;

  @Input() loadingData = false;
  @Input() download;
  @Output() callDataGrid = new EventEmitter();
  @Output() exportToExcel = new EventEmitter();
  @ViewChild('paginator', { static: true }) paginator: MatPaginator;
  page: number = 1;
  size: number = ListTableComponent.DEFAULT_PAGESIZE;
  //Arreglo de titulos usados en las tabla
  // headers: headersTable[];
  //Arreglo con los datos a mostrar en la trabla
  dataSource: any;
  //Order de la tabla
  //Se retorna el orden para poder relanzar la busqueda en el servicio que se implementa en la vista que llama a la tabla
  headersRow: string[];
  filters: OrdenTable[];
  orderBy: OrdenTable;
  lengthData: number;
  totalAmount: number = 0;
  pageSizeOptions: string[];
  fileNameDialogRef: MatDialogRef<ConfirmarDialogComponent>;
  footerColumns: string[];
  billeteras = {
    'com.yacare.test': 'Yacaré',
    'ar.com.santander': 'Santander Río',
    'com.mercadolibre': 'Mercado Pago',
    'ar.com.bna': 'BNA+',
    'com.columbia': 'Columbia',
    'ar.com.cuentadni': 'Cuenta DNI',
    'app.ank': 'Ank',
    'ar.com.reba': 'Reba',
    'ar.com.modo': 'MODO',
    'com.claro': 'Claro',
    'ar.com.moni': 'Moni'
  };

  headers: Array<headersTable>;

  appEnvironment: string;
  downloadLoading = false;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private data: DetailPaymentService,
    private paymentsService: PaymentsService,
    private paymentIconsService: PaymentIconsService,
    private translateService: TranslateService,
    private nativBridgeService: NativeBridgeService
  ) {
    this.appEnvironment = this.nativBridgeService.getEnvironment();
    this.headers = [
      {
        column: 'titulo',
        columnName: this.translate('pages.list_pay.labels.concept'),
        icon: false,
        id: 3,
        footer: false
      },
      {
        column: 'importe',
        columnName: this.translate('pages.list_pay.labels.amount'),
        icon: false,
        id: 5,
        footer: true
      },
      {
        column: 'medioPagoView',
        columnName: this.translate('pages.list_pay.labels.payment_method'),
        icon: true,
        id: 2,
        footer: false
      },
      { column: 'fecha', columnName: this.translate('pages.list_pay.labels.date'), icon: false, id: 1, footer: false }
    ] as headersTable[];
  }

  /*
        "Pendiente",
        "Aprobado",
        "Acreditado",
        "Confirmado",
        "Cancelado",
        "Anulado",
        "Rechazado",
        "Error"
    */
  setClassEstado(estado) {
    if (estado == 'Confirmado') return 'confirmado';
    else if (estado == 'Pendiente') return 'pendiente';
    else if (estado == 'Acreditado') return 'confirmado';
    else if (estado == 'Anulado') return 'anulado';
    else return 'error';
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }

  get buttonDownload() {
    return this.getBoolean(this.download);
  }

  evaluarTitulo(titulo: string) {
    if (titulo.startsWith('Ret.') || titulo.startsWith('Comisión') || titulo.startsWith('Devolución')) {
      return false;
    }
    return true;
  }

  maskCuit(cuit: string) {
    let first = cuit.substring(0, 2);
    let dni = cuit.substring(2, 10);
    let end = cuit.substring(10, 11);
    return `${first}-${dni}-${end}`;
  }

  public load(headers: headersTable[], dataSource: any[], dataLength: number, amount?: number) {
    this.totalAmount = 0;
    if (amount && amount > 0) {
      this.totalAmount = amount;
    }
    this.footerColumns = headers.filter((h) => h.footer).map((h) => h.column);
    this.lengthData = dataLength;
    this.loadViewForPage();
    this.dataSource = new MatTableDataSource<Element>(dataSource);
    this.headers = headers;
    this.filters = new Array<OrdenTable>();
    this.headersRow = new Array<string>();
    this.headers.forEach((element) => {
      this.headersRow.push(element.column);
      this.filters.push({
        id: this.filters.length,
        columnName: element.column,
        sortBy: SortEnum.ASC,
        sortOrderByDesc: false,
        sorterActive: false
      } as OrdenTable);
    });
  }

  public getTotalAmount() {
    return this.totalAmount
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&.')
      .replace(/.([^.]*)$/, ',$1');
  }

  orderFilter(index: number) {
    for (let i = 0; i < this.filters.length; i++) {
      if (index == i) {
        this.orderBy.sortBy = this.filters[i].sortBy;
        if (this.filters[i].sortOrder === SortEnum.ASC) {
          this.filters[i].sortOrder = SortEnum.DESC;
          this.filters[i].sortOrderByDesc = true;
        } else {
          this.filters[i].sortOrder = SortEnum.ASC;
          this.filters[i].sortOrderByDesc = false;
        }
        this.orderBy.sortOrder = this.filters[i].sortOrder;
      } else {
        this.filters[i].sortOrder = SortEnum.ASC;
        this.filters[i].sortOrderByDesc = false;
      }
    }
  }

  orderInTable() {
    this.orderBy.page = this.page;
    this.orderBy.size = this.size;
    return this.orderBy;
  }

  changePage(event) {
    this.size = event.pageSize;
    this.page = event.pageIndex + 1;
    this.callDataGrid.emit();
  }

  resetPage() {
    this.lengthData = 1;
    this.paginator.firstPage();
    this.loadViewForPage();
  }

  get _size(): number {
    return this.size;
  }
  get _page(): number {
    return this.page - 1;
  }

  loadViewForPage() {
    this.pageSizeOptions = new Array<string>();
    this.pageSizeOptions.push('5');
    this.pageSizeOptions.push('10');
    this.pageSizeOptions.push('15');
  }

  generateTitle(element, billetera?) {
    if (element == 'Transferencia 3.0' && billetera) {
      return this.billeteras[billetera];
    }
    return element;
  }

  getIcon(icon: string, billetera?: string): AppIcon {
    return this.paymentIconsService.getIcon(icon, billetera);
  }

  clickInAction(element: any, action: ActionOptions) {
    switch (action.name) {
      case 'pageview': {
        this.data.storage = element;
        const diagRef = this.dialog.open(DetailPayComponent, { minWidth: '350px' });
        diagRef.afterClosed().subscribe((x) => (x ? (x.refresh ? this.dataGrid() : null) : null));
        break;
      }

      case 'save_alt': {
        this.paymentsService
          .downloadTicket(element.id)
          .then(() => {
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
        break;
      }
    }
  }

  dataGrid() {
    this.callDataGrid.emit();
  }

  getColorImporte(importe) {
    if (Number(importe.split(',').join('')) > 0) {
      return 'text-right-success';
    } else {
      return 'text-right-danger';
    }
  }

  exportToExcelClickEventHandler(): void {
    this.exportToExcel.emit();
  }

  getBoolean(value) {
    switch (value) {
      case true:
      case 'true':
      case 'on':
      case 'yes':
        return true;
      default:
        return false;
    }
  }
}
